import React, { Component } from "react";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
import Radio from "../../../common/Radio/Radio";
import RadioContainer from "../../../common/CheckboxContainer/RadioContainer";

class RadioSelectionDropdown extends Component {
    constructor(props) {
      super(props);
      this.state = {
        listOpen: this.props.isOpen
      };
    }
    renderColumnNames = () => {
      return (
        <div className="col-md-12">
          <RadioContainer
            toggleSelection={this.props.toggleSelection}
            checkboxItemsList={this.props.checkboxItemsList}
          />

          
						{/* <Radio
							label="Email"							
							onClick={this.props.onSearchByChange}
							value={'Email'}
							checked={this.props.selectedSearchBy==="Email"}
						/>
						<Radio
							label="Phone"							
							onClick={this.props.RadioSelectionDropdownonSearchByChange}
							value={'Phone'}
							checked={this.props.selectedSearchBy==="Phone"}
							style={{ float: "left" }}
						/>
						<Radio
							label="InstanceID"							
							onClick={this.props.onSearchByChange}
							value={'InstanceID'}
							checked={this.props.selectedSearchBy==="InstanceID"}
							style={{ float: "left" }}
						/> */}
				</div>

         
      );
    };
  
    render() {
      const { listOpen } = this.state;
      return (
        <div>           
          {listOpen && (              
            <div className="divFloatingssColumnsDropdowns">
                <div className="row">
                   {this.renderColumnNames()}
                </div>
            </div>
          )}
        </div>
      );
    }
  }
  
  export default RadioSelectionDropdown;